.imaging-submitted .imaging.ng-invalid,.reactions-submitted .reaction.ng-invalid{border:red 1px solid!important;border-radius:2px}input.upload{border:0px solid red!important;margin:0 0 0 14px!important;width:100%;padding:2px!important}
/*# sourceMappingURL=imaging-files-add.component-C26IDEOG.css.map */
